import { convertWeight } from './weight-convert-service';

export const convertAndSumWeightValues = (weights, unit) => {
  const value = weights.reduce((total, weight) => {
    const weightValue = convertWeight(weight, unit).value;
    return total + weightValue || weightValue;
  }, 0);

  return {
    value,
    unit,
  };
};
